var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var postfixes = ['co', 'com'];
function parse(host) {
    var segs = host.split('.');
    if (segs.length === 1) {
        return {
            sub: '',
            domain: segs[0],
            top: '',
        };
    }
    var idx = segs.length - 1;
    for (var i = 0; i < postfixes.length; i++) {
        var postfix = postfixes[i];
        var index = segs.lastIndexOf(postfix);
        if (index !== -1) {
            idx = index;
            break;
        }
    }
    var sub = segs.slice(0, idx - 1).join('.');
    var domain = segs[idx - 1];
    var top = segs.slice(idx).join('.');
    return {
        sub: sub,
        domain: domain,
        top: top,
    };
}
var getSite = function () {
    var domain = parse(window.location.host).domain;
    if (domain === 'shop') {
        return 'daraz';
    }
    else {
        return domain;
    }
};
function transApproach(tag, options) {
    var _a = __read(tag.replace('-', '_').split('_'), 2), lang = _a[0], region = _a[1];
    return [
        lang,
        region ? [
            options.connector === 'underline' ? '_' : '-',
            options.region === 'uppercase' ? region.toUpperCase() : (options.region === 'lowercase' ?
                region.toLowerCase() :
                region),
        ].join('') : '',
    ].join('');
}
var SITE = getSite();
var MAP_LANG = {
    en: 'en-us',
    id: 'in-id',
    th: 'th-th',
    vi: 'vi-vn',
    ms: 'ms-my',
};
function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0)
            return c.substring(name.length, c.length);
    }
    return '';
}
function getCookieLocale() {
    var lang;
    if (SITE === 'aliexpress') {
        lang = getCookie('intl_locale');
    }
    else {
        lang = getCookie('_lang');
        lang = MAP_LANG[lang] || lang;
    }
    return transApproach(lang, {
        connector: 'dash',
        region: 'lowercase',
    });
}
export default getCookieLocale;
export { getCookie };

//# sourceMappingURL=cookie-utils.js.map
